@if (leg.official === false) {
  <div class="units">
    @for (result of leg.selections | orderBy:'display_order'; track $index) {
      <div class="unit-selections-2 _1x2">
        <div class="unit-item-2 _1x2">
          <div class="breakdown-score-2">
            @if (result.display_order%2!=0) {
              <span [transloco]="'selections.TITLE_YES'"></span>
            }
            @if (result.display_order%2==0) {
              <span [transloco]="'selections.TITLE_NO'"></span>
            }
          </div>
          <div class="breakdown-units-2">
            <span class="mr-0.5">{{getUnits(result.unit_distributions) | formatUnits }}</span>
            @if (getUnits(result.unit_distributions) != 0) {
              <span class="value" [transloco]="'poolUnitsDist.UNIT'"></span>
            }
          </div>
        </div>
      </div>
    }
  </div>
}
